/*
 * EM Dropdown portal — déplace les .em-hdr__dropdown au niveau body
 * pour échapper à tout stacking context parent
 */
(function () {
  function init() {
    document.querySelectorAll('.em-hdr__nav-item--has-children').forEach(setupItem);
  }

  function setupItem(item) {
    const dropdown = item.querySelector('.em-hdr__dropdown');
    if (!dropdown || dropdown.dataset.emPortaled) return;

    // Déplace au body
    document.body.appendChild(dropdown);
    dropdown.dataset.emPortaled = '1';
    dropdown.style.position = 'fixed';
    dropdown.style.left = '0';
    dropdown.style.top = '0';
    dropdown.style.transform = 'translate(0, 0)';

    let hideTimer = null;

    function position() {
      const rect = item.getBoundingClientRect();
      const ddRect = dropdown.getBoundingClientRect();
      const left = rect.left + rect.width / 2 - ddRect.width / 2;
      const top = rect.bottom + 8;
      dropdown.style.left = Math.max(8, left) + 'px';
      dropdown.style.top = top + 'px';
    }

    function show() {
      clearTimeout(hideTimer);
      // Reset transform pour mesurer ddRect correctement
      dropdown.style.opacity = '0';
      dropdown.style.visibility = 'visible';
      dropdown.style.pointerEvents = 'auto';
      requestAnimationFrame(() => {
        position();
        dropdown.style.opacity = '1';
      });
    }
    function hideSoon() {
      clearTimeout(hideTimer);
      hideTimer = setTimeout(() => {
        dropdown.style.opacity = '0';
        dropdown.style.visibility = 'hidden';
        dropdown.style.pointerEvents = 'none';
      }, 180);
    }

    item.addEventListener('mouseenter', show);
    item.addEventListener('mouseleave', hideSoon);
    item.addEventListener('focusin', show);
    dropdown.addEventListener('mouseenter', () => clearTimeout(hideTimer));
    dropdown.addEventListener('mouseleave', hideSoon);
    window.addEventListener('resize', () => {
      if (dropdown.style.visibility === 'visible') position();
    });
    window.addEventListener('scroll', () => {
      if (dropdown.style.visibility === 'visible') position();
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
